import React from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import { onLoad } from './utils';
import { GLOBAL_MODAL_CONTAINERS } from './constants';

/**
 * Serializes the layout data into a format accepted by the user session package.
 * @param {Context} options.context The current request's context.
 * @return {Object}
 */
const serializer = ({ context }) => ({
    autoShowSignUpEnabled: context.autoShowSignUpEnabled,
    storeLocationEnabled: context.storeLocationEnabled
});

/**
 *  Renders containers for user session client entry to kick in.
 */
const UserSessionContainers = () => {
    const { userId } = getContext();

    if (userId) {return null;}

    return (
        <>
            <div id={GLOBAL_MODAL_CONTAINERS.SIGN_IN}/>
            <div id={GLOBAL_MODAL_CONTAINERS.SIGN_UP}/>
        </>
    );
};

/**
 * Handles client side initialization
 */
const init = () => {
    window.addEventListener('load', onLoad);
};

export { serializer, UserSessionContainers };
export default init;
